import React, { useState } from 'react';
import cn from 'classnames';

import ICON_MINUS from 'assets/slickpay-splash/icon-minus.svg';
import ICON_PLUS from 'assets/slickpay-splash/icon-plus.svg';
import { useTranslation } from 'providers/GILT.provider';

import CN from './FaqItem.module.scss';

const FaqItem = ({ title, description, link, variant, isOpen }) => {
  const [toggle, setToggle] = useState(isOpen);
  const { t } = useTranslation();

  const componentClasses = cn({
    [CN.container]: true,
    [CN[`${variant}Variant`]]: variant,
    [CN.opened]: toggle,
  });

  return (
    <div data-bem="FaqItem" onClick={() => setToggle(!toggle)} role="button" tabIndex={0} className={componentClasses}>
      <div className={CN.title}>
        {title}
        <img src={toggle ? ICON_MINUS : ICON_PLUS} alt="Learn more" className={CN.toggleIcon} />
      </div>
      {toggle && (
        <div className={CN.description}>
          <div>{description}</div>

          {link && (
            <div className={CN.linkContainer}>
              <a href={link} target="_blank" rel="noopener noreferrer" className={CN.link}>
                {t('composite.faqItem.linkTitle')}
              </a>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FaqItem;
